import MenuIcon from '@mui/icons-material/Menu';
import { KeyboardArrowDown } from '@mui/icons-material';
import { SearchBar } from './SearchBar';
import { ThemeToggle } from './ThemeToggle';
import { NotificationBadge } from './NotificationBadge';
import { Avatar } from './Avatar';
import { NavbarConfig } from './types/navbar.types';
import styles from './Navbar.module.css';

interface NavbarProps {
	config: NavbarConfig;
	onMenuClick?: () => void;
	notificationsEnabled?: boolean;
}

export const Navbar = ({ config, onMenuClick, notificationsEnabled = true }: NavbarProps) => {
	const {
		title,
		user,
		onSearch,
		onNotificationClick,
		onUserMenuClick,
		notificationCount = 0,
		centerContent,
		titleContent,
	} = config;

	return (
		<header className={styles.navbar}>
			<div className={styles.left}>
				<button className={styles.menuButton} onClick={onMenuClick} aria-label="Abrir menu">
					<MenuIcon className={styles.menuIcon} />
				</button>
				{titleContent ?? <h1 className={styles.title}>{title}</h1>}
			</div>

			<div className={styles.right}>
				<SearchBar onSearch={onSearch} />

				<div className={styles.iconsGroup}>
					<ThemeToggle />
					{notificationsEnabled && (
						<NotificationBadge count={notificationCount} onClick={onNotificationClick} />
					)}
					<Avatar src={user.avatar} alt={user.name} onClick={onUserMenuClick} />
					<KeyboardArrowDown className={styles.arrowIcon} onClick={onUserMenuClick} />
				</div>
			</div>
			{centerContent && <div className={styles.centerContent}>{centerContent}</div>}
		</header>
	);
};
